import {
  SCULPTURE_MATERIALS_FEE_PER_SESSION,
  SUPPLIES_FEES,
  TRYOUT_TUITION_RATES,
  TUITION_RATES,
} from "./feeConstants"

export const TRYOUT_TABLE_COLUMNS = [
  "studentName",
  "progress",
  "className",
  "startDate",
  "startTime",
  "endTime",
  "notes",
  "semester",
]

// Re-export fee arrays for backward compatibility with tryout forms
// These are derived from the authoritative definitions in feeConstants.ts

// Supplies - re-exported from feeConstants
export const SUPPLIES_FEES_ARRAY = [
  SUPPLIES_FEES.coreArtBasicSupplies,
  SUPPLIES_FEES.coreArtGreenLimeSupplies,
  SUPPLIES_FEES.coreArtYellowOrangeRedSupplies,
  SUPPLIES_FEES.sketchingSupplies,
  SUPPLIES_FEES.collegePortfolioSupplies,
]

// Tuition - Semester
export const SEMESTER_TUITION_FEES = [
  {
    id: "standardSemesterTuition",
    label: "Standard Semester Tuition (Core Art/Sketching/Sculpture/Digital)",
    price: TUITION_RATES.standard.semester,
  },
  {
    id: "collegePortfolioSemesterTuition",
    label: "College Portfolio & AP Studio Art Semester Tuition",
    price: TUITION_RATES.portfolio.semester,
  },
]

// Tuition - Monthly
export const MONTHLY_TUITION_FEES = [
  {
    id: "standardMonthlyTuition",
    label: "Standard Monthly Tuition (Core Art/Sketching/Sculpture/Digital)",
    price: TUITION_RATES.standard.monthly,
  },
  {
    id: "collegePortfolioMonthlyTuition",
    label: "College Portfolio & AP Studio Art Monthly Tuition",
    price: TUITION_RATES.portfolio.semester,
  },
]

// Tryout Tuition
export const TRYOUT_TUITION_FEES = [
  {
    id: "standardTryoutTuition",
    label: "Standard Tryout Tuition (Core Art/Sketching/Sculpture/Digital)",
    price: TRYOUT_TUITION_RATES.standard,
  },
  {
    id: "collegePortfolioTryoutTuition",
    label: "College Portfolio & AP Studio Art Tryout Tuition",
    price: TRYOUT_TUITION_RATES.portfolio,
  },
]

// Other Fees
export const OTHER_FEES = [
  {
    id: "sculptureMaterialsFee",
    label: "Sculpture Materials Fee (per class)",
    price: SCULPTURE_MATERIALS_FEE_PER_SESSION,
  },
]

export const TRYOUT_FEES_GROUPED = [
  {
    label: "Tryout Tuition",
    options: TRYOUT_TUITION_FEES.map((fee) => ({
      label: `${fee.label} - $${fee.price}`,
      value: fee.id,
    })),
  },
]

// Combined array for backward compatibility
export const TRYOUT_FEES = [
  ...SUPPLIES_FEES_ARRAY,
  ...SEMESTER_TUITION_FEES,
  ...MONTHLY_TUITION_FEES,
  ...TRYOUT_TUITION_FEES,
  ...OTHER_FEES,
]

export const FEE_OPTIONS = TRYOUT_FEES.map((fee) => ({
  label: `${fee.label} - $${fee.price}`,
  value: fee.id,
}))

export const FEE_OPTIONS_GROUPED = [
  {
    label: "Tryout Tuition",
    options: TRYOUT_TUITION_FEES.map((fee) => ({
      label: `${fee.label} - $${fee.price}`,
      value: fee.id,
    })),
  },
  {
    label: "Supplies",
    options: SUPPLIES_FEES_ARRAY.map((fee) => ({
      label: `${fee.label} - $${fee.price}`,
      value: fee.id,
    })),
  },
  {
    label: "Other Fees",
    options: OTHER_FEES.map((fee) => ({
      label: `${fee.label} - $${fee.price}`,
      value: fee.id,
    })),
  },
  {
    label: "Tuition - Semester",
    options: SEMESTER_TUITION_FEES.map((fee) => ({
      label: `${fee.label} - $${fee.price}`,
      value: fee.id,
    })),
  },
  {
    label: "Tuition - Monthly",
    options: MONTHLY_TUITION_FEES.map((fee) => ({
      label: `${fee.label} - $${fee.price}`,
      value: fee.id,
    })),
  },
]
